import { Api } from '@fnv-core/http';

const CONSENT_API_PREFIX = 'consentdetail';

/**
 * Service for managing consents
 */
export class ConsentService {

  /**
   * Accept the given consent
   * @param consentId
   * @returns 
   */
  static async accept(consentId: string) {
    await this.callApi('accept', consentId);
  }

  /**
   * Revoke the given consent
   * @param consentId
   * @returns 
   */
   static async revoke(consentId: string) {
    await this.callApi('revoke', consentId);
  }

  private static async callApi(type: string, consentId: string) {
    const apiOptions = { 
      injectUserId: true,
      useApiPrefix: true
    };
    const response = await Api.post<null>(`${CONSENT_API_PREFIX}/${type}/{userId}/${consentId}`, null, apiOptions);
    return response;
  }
}
